// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mb-8[data-v-38d0f97a]{margin-bottom:8px}.label-custom[data-v-38d0f97a]{font-weight:400;font-size:14px;line-height:20px}.zm-color-picker-custom[data-v-38d0f97a] .el-input__inner{border:1px solid #fff}", ""]);
// Exports
module.exports = exports;
